import { render, staticRenderFns } from "./materialCollection.vue?vue&type=template&id=2f0c78f3&scoped=true&"
import script from "./materialCollection.vue?vue&type=script&lang=js&"
export * from "./materialCollection.vue?vue&type=script&lang=js&"
import style0 from "./materialCollection.vue?vue&type=style&index=0&id=2f0c78f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c78f3",
  null
  
)

export default component.exports